module.exports = __webpack_public_path__ + "img/002.47c89392.jpg";